import React from 'react';
import Icon from '@mdi/react';
import { mdiTrashCan } from '@mdi/js';

const TrashIcon = (props) => {
  return <Icon path={mdiTrashCan} {...props} />;
};

export default TrashIcon;
